import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Icon, ModuleTile } from '@platform/ui';
import { cx } from '@platform/core/lib/cx';
import type { IModuleCardViewProps } from './IModuleCardViewProps';

/**
 * Плитка модуля (прототип v4, сторінка «Усі модулі»): рамка 1px, радіус 10, відступ 12px; рядок — плитка 30px із градієнтом тону й
 * зірка закріплення праворуч (★ акцентна / ☆ приглушена); назва 600; опис 12px у два рядки; «N записів» IBM Plex Mono 11px.
 * Уся плитка клікабельна (розтягнуте посилання), зірка — окрема кнопка поверх нього.
 */
export function ModuleCardView({ card, onPin }: IModuleCardViewProps) {
  const { t } = useTranslation();
  const pinTitle = card.pinned ? t('allModules.unpin') : t('allModules.pin');
  const name = card.to
    ? <Link className="am-card__name am-card__link" to={card.to}>{card.name}</Link>
    : <button type="button" className="am-card__name am-card__link" onClick={card.onOpen}>{card.name}</button>;
  return (
    <div className="am-card">
      <div className="am-card__top">
        <ModuleTile icon={card.icon} tone={card.tone} size={30} raised />
        {onPin && card.pinned !== undefined && (
          <button type="button" className={cx('am-card__pin', card.pinned && 'is-on')} title={pinTitle} aria-label={`${pinTitle}: ${card.name}`} aria-pressed={card.pinned}
            onClick={() => onPin(card.key.split('/')[0]!)}>
            <Icon name="star" size={15} strokeWidth={1.8} filled={card.pinned} />
          </button>
        )}
      </div>
      {name}
      <span className="am-card__desc">{card.description}</span>
      <span className="am-card__count">{card.count !== undefined ? t('modules.records', { count: card.count }) : t('allModules.systemModule')}</span>
    </div>
  );
}
